import { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'
import { DesktopLayout } from './DesktopLayout'
import { MobileLayout } from './MobileLayout'
import { useLayout } from '../../hooks/useLayout'

interface LayoutProps {
  children: ReactNode
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation()
  const { isMobile } = useLayout()

  // Routes that should not show any layout (showcase and development pages)
  const noLayoutRoutes = ['/dev', '/showcase-old', '/brand-showcase', '/theme-showcase', '/layout-showcase', '/image-containers']
  const isNoLayoutRoute = noLayoutRoutes.some(route => location.pathname === route || location.pathname.startsWith(route + '/'))

  // No layout for showcase/development pages
  if (isNoLayoutRoute) {
    return (
      <div className="min-h-screen">
        {children}
      </div>
    )
  }

  // Switch between mobile and desktop layout based on viewport
  if (isMobile) {
    return (
      <MobileLayout>
        {children}
      </MobileLayout>
    )
  }

  return (
    <DesktopLayout>
      {children}
    </DesktopLayout>
  )
}
